import { useNextButtonStyles } from "domains/Fidelity/style";
import { NextIcon } from "icons";
import React from "react";

interface NextButtonProps {
  onClick: () => void;
}
function NextButton({ onClick }: NextButtonProps) {
  const styles = useNextButtonStyles();
  return (
    <div className={styles.button} onClick={onClick}>
      <NextIcon width={40} height={40} />
    </div>
  );
}

export default NextButton;
